export default class CXAIFiltersViewModel {
    public isActive: boolean = false;
    public channel: string = '';
    public question: string = '';
    //public category: string = '';
    public answer: string = '';
}